import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {BlacklistContactFilter, BlacklistGeneralFilter, BlacklistItem, BlacklistsState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<BlacklistsState, RootState> = {
    getBlacklists: ({commit, dispatch}, data) => {
        // commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/acapi/blacklists', params: data})
                .then(resp => {
                    if (data?.page_number > 1) {
                        commit("pushBlacklists", resp.data.blacklists);
                    } else {
                        commit('setBlacklists', resp.data.blacklists);
                    }
                    resolve(resp.data.blacklists)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getBlackListItem: ({commit, dispatch}, id: number) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/blacklists/${id}`})
                .then((resp: any) => {
                    let blacklistItem = <BlacklistItem>resp.data;
                    blacklistItem.id = id;
                    commit('setBlackListItem', blacklistItem);
                    resolve(blacklistItem)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveBlackList: ({commit, dispatch}, data: BlacklistItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: '/acapi/blacklists/' + (data.id ?? ''),
                data: data
            })
                .then((resp: any) => {
                    dispatch('getBlacklists');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteBlackList: ({commit, dispatch}, data: BlacklistItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/blacklists/${data.id}`,
                data: data
            })
                .then((resp: any) => {
                    dispatch('getBlacklists');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    exportBlackListContacts: ({commit}, data: {blacklistId: number, filter: BlacklistContactFilter}) => {
        return directDownload(`/acapi/blacklists/${data.blacklistId}/recipients/export`, data.filter)
    },
    importBlackListContacts: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise(async (resolve, reject) => {
            axios({
                method: 'post',
                url: `/acapi/blacklists/${data.id}/recipients/import`,
                data: data.item
            })
                .then((resp: any) => {
                    dispatch('getBlackListContacts', {blacklistId: data.id});
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getBlackListContacts: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/blacklists/${data.blacklistId}/recipients`, params: data})
                .then((resp: any) => {
                    let recipients = resp.data?.recipients ?? [];
                    if (data.page_number > 1) {
                        commit("pushBlacklistContacts", recipients);
                    } else {
                        commit("setBlacklistContacts", recipients);
                    }
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getBlackListContactItem: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/blacklists/${data.blacklistId}/recipients/${data.id}`})
                .then((resp: any) => {
                    commit('setBlackListContactItem', resp.data);
                    resolve(resp.data)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveBlackListContact: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: data.id ? 'put' : 'post',
                url: `/acapi/blacklists/${data.blacklistId}/recipients/${data.id ?? ''}`,
                data: data.item
            })
                .then((resp: any) => {
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteBlackListContact: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/blacklists/${data.blacklistId}/recipients/${data.id}`,
                data: {
                    recipient_ids: data.recipientIds
                }
            })
                .then((resp: any) => {
                    dispatch('getBlackListContacts', data.id);
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteBlackListContacts: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'delete',
                url: `/acapi/blacklists/${data.id}/recipients`,
                data: {
                    recipient_ids: data.recipientIds
                }
            })
                .then((resp: any) => {
                    dispatch('getBlackListContacts', {blacklistId: data.id});
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getBlackListGlobals: ({ commit }) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/blacklists/general`})
                .then((resp: any) => {
                    commit('setBlackListGlobals', resp.data?.blacklists);
                    resolve(resp.data.blacklists)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getBlackListGenerals: ({ commit }, data: BlacklistGeneralFilter) => {
        commit('setLoading', true);
        const { channel, ...params } = data;
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/blacklists/general/${channel}/recipients`, params: params})
                .then((resp: any) => {
                    let recipients = resp.data?.recipients ?? [];
                    if (data?.page_number > 1) {
                        commit("pushBlacklistGenerals", recipients);
                    } else {
                        commit("setBlacklistGenerals", recipients);
                    }
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getBlackListGeneralItem: ({commit, dispatch}, params: {channel: string, id: number}) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/blacklists/general/${params.channel}/recipients/${params.id}`})
                .then((resp: any) => {
                    commit('setBlacklistGeneralItem', resp.data);
                    resolve(resp.data)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    saveBlackListGeneral: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            const { channel, ...params } = data;
            axios({
                method: params.id ? 'put' : 'post',
                url: `/acapi/blacklists/general/${channel}/recipients/${params.id ?? ''}`,
                data: params.item
            })
                .then((resp: any) => {
                    dispatch('getBlackListGenerals', data);
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteBlackListGeneral: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            const { channel, ...params } = data;
            axios({
                method: 'delete',
                url: `/acapi/blacklists/general/${channel}/recipients/${params.id}`,
                data: {
                    id: params.id
                }
            })
                .then((resp: any) => {
                    dispatch('getBlackListGenerals', data);
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    deleteBlackListGenerals: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            const { channel, recipientIds } = data;
            axios({
                method: 'delete',
                url: `/acapi/blacklists/general/${channel}/recipients`,
                data: {
                    recipient_ids: recipientIds
                }
            })
                .then((resp: any) => {
                    dispatch('getBlackListGenerals', {channel: channel});
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    exportBlackListGenerals: ({}, data: BlacklistGeneralFilter) => {
        const { channel, ...params } = data;
        return directDownload(`/acapi/blacklists/general/${channel}/recipients/export`, params)
    },
    importBlackListGenerals: ({commit, dispatch}, data: any) => {
        commit('setLoading', true);
        return new Promise(async (resolve, reject) => {
            const { channel, ...params } = data;
            axios({
                method: 'post',
                url: `/acapi/blacklists/general/${channel}/recipients/import`,
                data: params.item
            })
                .then((resp: any) => {
                    dispatch('getBlackListGenerals', {channel: channel});
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
};
